import axios from 'axios'

export default  {
  namespaced: true,

  state: {
    types: [],
  },

  mutations: {
    getTypesSuccess(state, types) {
      state.types = types
    },
  },

  actions: {

    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/admin/notification_campaign/${id}`)
          .then((res) => {
            resolve(res.data.data.campaign)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    create({commit}, campaignForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/admin/notification_campaign', campaignForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    update({commit}, campaignForm) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin/notification_campaign/${campaignForm.get('id')}`, campaignForm)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    delete({commit}, campaignId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin/notification_campaign/${campaignId}`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    restore({commit}, campaignId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin/notification_campaign/${campaignId}/restore`)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  getters: {
    types: (state) => state.types,
  },
}
